/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection11FoiChanged, m11ReportSection11ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection11Foi, selectM11ReportSection11Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialOversightChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section11State, setAlertModalState, setStartingSection11State) => {

    let changesStates = {
        section11State: section11State
    };
    let response = await saveM11Changes(apiToken, 36, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection11Resource) {
            dispatch(m11ReportSection11ResourceChanged(response.m11ReportSection11Resource));
        }
        setStartingSection11State(JSON.parse(JSON.stringify(section11State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step036TrialOversightPart2 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection11Foi = useSelector(selectM11ReportSection11Foi);
    const m11ReportSection11Resource = useSelector(selectM11ReportSection11Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section11State, setSection11State] = useState({
        "section113Status": "empty", "section113Xhtml": "",
        "section1131Status": "empty", "section1131Xhtml": "",
        "section1132Status": "empty", "section1132Xhtml": "",
        "section114Status": "empty", "section114Xhtml": "",
        "section115Status": "empty", "section115Xhtml": "",
        "section116Status": "empty", "section116Xhtml": ""
    });
    const [startingSection11State, setStartingSection11State] = useState({
        "section113Status": "empty", "section113Xhtml": "",
        "section1131Status": "empty", "section1131Xhtml": "",
        "section1132Status": "empty", "section1132Xhtml": "",
        "section114Status": "empty", "section114Xhtml": "",
        "section115Status": "empty", "section115Xhtml": "",
        "section116Status": "empty", "section116Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section11State, startingSection11State)),
        async saveAllChanges() {
            await saveTrialOversightChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section11State, setAlertModalState, setStartingSection11State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section113Status": "empty", "section113Xhtml": "",
                "section1131Status": "empty", "section1131Xhtml": "",
                "section1132Status": "empty", "section1132Xhtml": "",
                "section114Status": "empty", "section114Xhtml": "",
                "section115Status": "empty", "section115Xhtml": "",
                "section116Status": "empty", "section116Xhtml": "",
                "loaded": true
            };
            setSection11State(startingData);
            setStartingSection11State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[11]?.entry?.length) {
                let m11ReportSection011Foi = getIdFromReference(m11ReportContainerResource.section[11].entry[0]);
                if (m11ReportSection011Foi && !isNaN(m11ReportSection011Foi) &&
                    m11ReportSection011Foi !== m11ReportSection11Foi) {
                    dispatch(m11ReportSection11FoiChanged(m11ReportSection011Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection11Foi && !isNaN(m11ReportSection11Foi)) {
            loadResource(m11ReportSection11Foi, "M11ReportSection11", apiToken, dispatch);
        }
    }, [m11ReportSection11Foi]);

    useEffect(() => {
        if (m11ReportSection11Resource && Object.keys(m11ReportSection11Resource).length > 0) {
            let startingData = {
                "section113Status": "empty", "section113Xhtml": "",
                "section1131Status": "empty", "section1131Xhtml": "",
                "section1132Status": "empty", "section1132Xhtml": "",
                "section114Status": "empty", "section114Xhtml": "",
                "section115Status": "empty", "section115Xhtml": "",
                "section116Status": "empty", "section116Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection11Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection11Resource.section[0].section[2]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[2].text.status !== "empty") {
                    startingData.section113Status = m11ReportSection11Resource.section[0].section[2].text.status;
                    startingData.section113Xhtml = m11ReportSection11Resource.section[0].section[2].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[2]?.section?.length > 0) {
                    if (m11ReportSection11Resource.section[0].section[2].section[0]?.text?.div &&
                        m11ReportSection11Resource.section[0].section[2].section[0].text.status !== "empty") {
                        startingData.section1131Status = m11ReportSection11Resource.section[0].section[2].section[0].text.status;
                        startingData.section1131Xhtml = m11ReportSection11Resource.section[0].section[2].section[0].text.div;
                    }
                    if (m11ReportSection11Resource.section[0].section[2].section[1]?.text?.div &&
                        m11ReportSection11Resource.section[0].section[2].section[1].text.status !== "empty") {
                        startingData.section1132Status = m11ReportSection11Resource.section[0].section[2].section[1].text.status;
                        startingData.section1132Xhtml = m11ReportSection11Resource.section[0].section[2].section[1].text.div;
                    }
                }
                if (m11ReportSection11Resource.section[0].section[3]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[3].text.status !== "empty") {
                    startingData.section114Status = m11ReportSection11Resource.section[0].section[3].text.status;
                    startingData.section114Xhtml = m11ReportSection11Resource.section[0].section[3].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[4]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[4].text.status !== "empty") {
                    startingData.section115Status = m11ReportSection11Resource.section[0].section[4].text.status;
                    startingData.section115Xhtml = m11ReportSection11Resource.section[0].section[4].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[5]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[5].text.status !== "empty") {
                    startingData.section116Status = m11ReportSection11Resource.section[0].section[5].text.status;
                    startingData.section116Xhtml = m11ReportSection11Resource.section[0].section[5].text.div;
                }
                setSection11State(startingData);
                setStartingSection11State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection11Resource]);

    return <div>
        <h3>Continue Section 11 Trial Oversight and Other General Considerations</h3>
        {!(m11ReportSection11Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 36 (Continue Section 11 Trial Oversight and Other General Considerations) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section11State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.3 Informed Consent Process summary as needed.</h4>
                    <TextDivEntry elementName="section113Xhtml"
                        startingValue={section11State.section113Xhtml}
                        setResourceState={setSection11State} />
                    <h5 style={{ marginBottom: "0px" }}>Revise Section 11.3.1 Informed Consent for Rescreening as needed.</h5>
                    <TextDivEntry elementName="section1131Xhtml"
                        startingValue={section11State.section1131Xhtml}
                        setResourceState={setSection11State} />
                    <h5 style={{ marginBottom: "0px" }}>Revise Section 11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research as needed.</h5>
                    <TextDivEntry elementName="section1132Xhtml"
                        startingValue={section11State.section1132Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.4 Committees summary as needed.</h4>
                    <TextDivEntry elementName="section114Xhtml"
                        startingValue={section11State.section114Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.5 Insurance and Indemnity summary as needed.</h4>
                    <TextDivEntry elementName="section115Xhtml"
                        startingValue={section11State.section115Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.6 Risk-Based Quality Management summary as needed.</h4>
                    <TextDivEntry elementName="section116Xhtml"
                        startingValue={section11State.section116Xhtml}
                        setResourceState={setSection11State} />
                </>}
            </>
        }
    </div >
});

const M11Step036TrialOversightPart2HelperText = <div>
    <h3>Continue Section 11 Trial Oversight and Other General Considerations</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 11.3 Informed Consent Process.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Specify the key elements of the informed consent process, including any special needs and how these are addressed (e.g., assent, capacity, legally acceptable representative, adolescents who may reach age of majority during the trial, pregnant participants and pregnant partners of participants).</p>
            <p>If enrollment in the trial may occur during an emergency in which the participant or their legally acceptable representative is not able or available to give consent, describe the consent process.</p>
        </div>
        <p>If applicable, enter data for Section 11.3.1 Informed Consent for Rescreening.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If participants can be rescreened as described in Section 5.6 Screen Failure and Rescreening, state whether the participant needs to complete a new ICF. Screen failure and rescreening should be clearly defined in the protocol, with a cross reference to those definitions.</p>
        </div>
        <p>If applicable, enter data for Section 11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If participants will be asked to consent to optional exploratory research using the remainder of mandatory samples, describe the use of remaining samples for optional exploratory research.</p>
            <p>If any exploratory research is planned and additional written consent regarding the use of remaining samples for exploratory research will be obtained, describe the consent process.</p>
        </div>
        <p>Enter data for Section 11.4 Committees.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Briefly describe the administrative structure of committees that will be reviewing data while the trial is ongoing, and the type of committee (e.g., Dose Escalation Committee, Data Monitoring Committee or Data Safety Monitoring Board). Note that specific details may be required depending on local law or regulation. If applicable, committee charters may be cross referenced. If no committees are involved, state “Not applicable.”</p>
        </div>
        <p>Enter data for Section 11.5 Insurance and Indemnity.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Concisely summarise the arrangements for participant insurance and indemnity if not addressed in a separate agreement, if required by the applicable regulatory requirements.</p>
        </div>
        <p>Enter data for Section 11.6 Risk-Based Quality Management.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the identified critical to quality factors, associated risks and risk mitigation strategies for the trial or refer to the location where this information is described and updated during the trial based on emerging data.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step036TrialOversightPart2ValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 36, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 36 (Continue Section 11 Trial Oversight and Other General Considerations) {validationCheckState.step36numberOfChecks} issues checked. {validationCheckState.step36numberPassed} passed. {validationCheckState.step36numberFailed} failed.</h4>
        <p>Section 11.3 heading is 'Informed Consent Process': {validationCheckState.resultCheckSection113Heading}</p>
        <p>Section 11.3 Informed Consent Process does not have text: {validationCheckState.resultCheckSection113Content}</p>
        <p>If present, Section 11.3.1 heading is 'Informed Consent for Rescreening': {validationCheckState.resultCheckSection1131Heading}</p>
        <p>If present, Section 11.3.1 Informed Consent for Rescreening has content: {validationCheckState.resultCheckSection1131Content}</p>
        <p>If present, Section 11.3.2 heading is 'Informed Consent for Use of Remaining Samples in Exploratory Research': {validationCheckState.resultCheckSection1132Heading}</p>
        <p>If present, Section 11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research has content: {validationCheckState.resultCheckSection1132Content}</p>
        <p>Section 11.4 heading is 'Committees': {validationCheckState.resultCheckSection114Heading}</p>
        <p>Section 11.4 Committees has content: {validationCheckState.resultCheckSection114Content}</p>
        <p>Section 11.5 heading is 'Insurance and Indemnity': {validationCheckState.resultCheckSection115Heading}</p>
        <p>Section 11.5 Insurance and Indemnity has content: {validationCheckState.resultCheckSection115Content}</p>
        <p>Section 11.6 heading is 'Risk-Based Quality Management': {validationCheckState.resultCheckSection116Heading}</p>
        <p>Section 11.6 Risk-Based Quality Management has content: {validationCheckState.resultCheckSection116Content}</p>
    </div>}  </div>
}

export default M11Step036TrialOversightPart2;
export { M11Step036TrialOversightPart2HelperText, M11Step036TrialOversightPart2ValidationCheck };